/*
 * membraclean language detection.
 * Shopify localization forms remain the source of truth for manual selection.
 * Available published locales are rendered dynamically by Liquid.
 */
(function () {
  'use strict';

  var node = document.getElementById('mc-auto-language-config');
  if (!node) return;

  var settings;
  try { settings = JSON.parse(node.textContent); } catch (_) { return; }
  if (!settings || !Array.isArray(settings.languages)) return;

  var locales = settings.languages.filter(function (language) {
    return language && typeof language.code === 'string';
  });
  if (locales.length < 2) return;

  var manualKey = 'mc_manual_language_v1';
  var attemptKey = 'mc_auto_language_attempt_v1';

  function findLocale(code) {
    if (!code) return null;
    var normalized = String(code).toLowerCase().replace(/_/g, '-');
    for (var i = 0; i < locales.length; i++) {
      if (locales[i].code.toLowerCase() === normalized) return locales[i];
    }
    var base = normalized.split('-')[0];
    for (var j = 0; j < locales.length; j++) {
      if (locales[j].code.toLowerCase() === base) return locales[j];
    }
    return null;
  }

  function savedManualLanguage() {
    try { return localStorage.getItem(manualKey); } catch (_) { return null; }
  }

  // Dedicated Danish and Italian markets must be selected with their languages.
  // Shopify remains responsible for pricing; no client-side conversion.
  var marketAttemptKey = 'mc_language_market_attempt_v2';
  var marketSelectionKey = 'mc_selected_market_v1';

  function currentCountry() {
    return String((window.Shopify && window.Shopify.country) || settings.country || '').toUpperCase();
  }

  function setHiddenField(form, name, value) {
    var field = form.querySelector('input[name="' + name + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  }

  function prepareMarket(form, code) {
    var language = String(code || '').toLowerCase().split('-')[0];
    var country = '';
    if (language === 'da') {
      country = 'DK';
    } else if (language === 'it') {
      country = 'IT';
    } else if (currentCountry() === 'DK' || currentCountry() === 'IT' || settings.current === 'da' || settings.current === 'it') {
      // Switch back to each published DE/NL/FR market when leaving DK or IT.
      country = { de: 'DE', nl: 'NL', fr: 'FR' }[language] || '';
    }
    // Respect a separate, explicit country selector if one is present.
    if (!country || form.querySelector('select[name="country_code"]')) return '';
    setHiddenField(form, 'country_code', country);
    return country;
  }

  function rememberMarket(country) {
    if (!country) return;
    try { sessionStorage.setItem(marketSelectionKey, country); } catch (_) {}
  }

  function prepareLanguageForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      var type = forms[i].querySelector('input[name="form_type"]');
      var language = forms[i].querySelector('input[name="language_code"], select[name="language_code"]');
      if (type && type.value === 'localization' && language) prepareMarket(forms[i], language.value);
    }
  }

  function synchronizeNationalEntry() {
    var targetCountry = settings.current === 'da' ? 'DK' : (settings.current === 'it' ? 'IT' : '');
    if (!targetCountry) return false;
    var country = currentCountry();
    if (country === targetCountry) {
      try { sessionStorage.removeItem(marketAttemptKey); } catch (_) {}
      return false;
    }
    // Unknown context is not enough reason to force a redirect.
    if (!country) return false;
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      var type = forms[i].querySelector('input[name="form_type"]');
      var language = forms[i].querySelector('input[name="language_code"], select[name="language_code"]');
      if (!type || type.value !== 'localization' || !language || language.value !== settings.current) continue;
      if (prepareMarket(forms[i], settings.current) !== targetCountry) continue;
      // One automatic retry per minute across all paths, never a redirect loop.
      // With blocked storage, explicit flag selection still works normally.
      try {
        var previous = Number(sessionStorage.getItem(marketAttemptKey) || 0);
        if (previous && Date.now() - previous < 60000) return false;
        sessionStorage.setItem(marketAttemptKey, String(Date.now()));
      } catch (_) { return false; }
      var target = new URL(window.location.href);
      target.searchParams.delete('country');
      target.searchParams.delete('currency');
      setHiddenField(forms[i], 'return_to', target.pathname + target.search + target.hash);
      rememberMarket(targetCountry);
      HTMLFormElement.prototype.submit.call(forms[i]);
      return true;
    }
    return false;
  }

  // Only user-triggered localization forms set an overriding preference.
  // Programmatic form.submit() intentionally does not dispatch a submit event.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !form.querySelector) return;
    var formType = form.querySelector('input[name="form_type"]');
    var field = form.querySelector('input[name="language_code"], select[name="language_code"]');
    if (!formType || formType.value !== 'localization' || !field) return;
    var selected = findLocale(field.value);
    if (!selected) return;
    rememberMarket(prepareMarket(form, selected.code));
    try { localStorage.setItem(manualKey, selected.code); } catch (_) {}
  }, true);

  // Shopify handles user-chosen locale URLs and the theme customizer itself.
  if (settings.designMode || (window.Shopify && window.Shopify.designMode)) return;
  if (window.top !== window.self) return;
  if (/bot|crawl|spider|slurp|lighthouse|pagespeed|prerender|facebookexternalhit|twitterbot|bingpreview/i.test(navigator.userAgent || '')) return;

  var pathname = window.location.pathname || '/';
  var previewRequest = /(?:^|[?&])(?:preview_theme_id|_ab|pb|design_theme_id|locale|language)=/i.test(window.location.search);
  if (!previewRequest) {
    prepareLanguageForms();
    document.addEventListener('shopify:section:load', prepareLanguageForms);
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      var lastMarket;
      try { lastMarket = sessionStorage.getItem(marketSelectionKey); } catch (_) {}
      if (lastMarket && currentCountry() && lastMarket !== currentCountry()) {
        window.location.reload();
        return;
      }
      synchronizeNationalEntry();
    });
    if (settings.current === 'da' || settings.current === 'it') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', synchronizeNationalEntry, { once: true });
      } else {
        synchronizeNationalEntry();
      }
      return;
    }
  }
  if (settings.current !== settings.primary) return;

  if (/^\/(?:cart|checkout|checkouts|account|challenge|password|apps|admin)(?:\/|$)/i.test(pathname)) return;
  if (/^\/policies(?:\/|$)/i.test(pathname)) return;
  if (/(?:^|[?&])(?:preview_theme_id|_ab|pb|design_theme_id|locale|language)=/i.test(window.location.search)) return;

  var selected = findLocale(savedManualLanguage());
  if (!selected) {
    var preferences = (navigator.languages && navigator.languages.length)
      ? navigator.languages : [navigator.language || ''];
    for (var j = 0; j < preferences.length; j++) {
      selected = findLocale(preferences[j]);
      // Luxembourgish has no published locale yet. Offer French as a fallback.
      // Keep exact language matches first, so a future lb translation wins.
      if (!selected && /^lb(?:[-_]|$)/i.test(preferences[j])) {
        selected = findLocale('fr');
      }
      if (selected) break;
    }
  }
  if (!selected || selected.code === settings.current) return;

  // Shopify's localization form selects a language without guessing translated URLs.
  // Prevent rapid repeat submits if the market cannot resolve the locale.
  var attempt = selected.code + '|' + pathname;
  try {
    var previous = JSON.parse(sessionStorage.getItem(attemptKey) || 'null');
    if (previous && previous.key === attempt && Date.now() - previous.time < 15000) return;
    sessionStorage.setItem(attemptKey, JSON.stringify({ key: attempt, time: Date.now() }));
  } catch (_) {}

  function submitShopifyLocaleForm() {
    var forms = document.querySelectorAll('form');
    for (var k = 0; k < forms.length; k++) {
      var formType = forms[k].querySelector('input[name="form_type"]');
      var language = forms[k].querySelector('input[name="language_code"], select[name="language_code"]');
      if (formType && formType.value === 'localization' && language && language.value === selected.code) {
        rememberMarket(prepareMarket(forms[k], selected.code));
        HTMLFormElement.prototype.submit.call(forms[k]);
        return true;
      }
    }
    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      submitShopifyLocaleForm();
    }, { once: true });
  } else {
    submitShopifyLocaleForm();
  }
})();
